var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "prpd" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("validation-provider", {
            attrs: {
              rules: "area",
              mode: "lazy",
              name: _vm.nomeAba + "/Área destinada à recuperação"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("Label", {
                          attrs: {
                            label: "Área destinada à recuperação",
                            obrigatorio: true
                          }
                        }),
                        _vm._v(" "),
                        _c("AppDoubleInput", {
                          class: { "input erro": errors.length },
                          attrs: {
                            name: "Área destinada à recuperação",
                            precision: 2,
                            onkeypress: _vm.onlyInputNumbers,
                            showAppend: true
                          },
                          model: {
                            value: _vm.pratica.areaDestinada,
                            callback: function($$v) {
                              _vm.$set(_vm.pratica, "areaDestinada", $$v)
                            },
                            expression: "pratica.areaDestinada"
                          }
                        }),
                        _vm._v(" "),
                        errors[0]
                          ? _c("span", { staticClass: "help erro" }, [
                              _vm._v(" " + _vm._s(errors[0]))
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("validation-provider", {
            attrs: {
              rules: "required",
              mode: "lazy",
              name: _vm.nomeAba + "/Data início da recuperação"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c("Label", {
                          attrs: {
                            label: "Data de início do processo de recuperação",
                            obrigatorio: true
                          }
                        }),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          class: { "input erro": errors.length },
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "month",
                            placeholder: "Selecione mês e ano",
                            format: "MM/yyyy",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.pratica.dataInicio,
                            callback: function($$v) {
                              _vm.$set(_vm.pratica, "dataInicio", $$v)
                            },
                            expression: "pratica.dataInicio"
                          }
                        }),
                        _vm._v(" "),
                        errors[0]
                          ? _c("span", { staticClass: "help erro" }, [
                              _vm._v(" " + _vm._s(errors[0]))
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("InputSelect", {
            attrs: {
              label: "Grau de degradação da área",
              nomeAba: _vm.nomeAba,
              obrigatorio: true,
              rulesInput: "required",
              opcoes: _vm.opcoesGrauDegradacao,
              widthColumn: 8
            },
            model: {
              value: _vm.pratica.grauDegradacao,
              callback: function($$v) {
                _vm.$set(_vm.pratica, "grauDegradacao", $$v)
              },
              expression: "pratica.grauDegradacao"
            }
          }),
          _vm._v(" "),
          _c("InputSelect", {
            attrs: {
              label: "Foi realizada análise de solo antes da recuperação?",
              nomeAba: _vm.nomeAba,
              obrigatorio: true,
              rulesInput: "required",
              opcoes: _vm.opcoesSimNao,
              widthColumn: 10
            },
            model: {
              value: _vm.pratica.hasAnaliseSolo,
              callback: function($$v) {
                _vm.$set(_vm.pratica, "hasAnaliseSolo", $$v)
              },
              expression: "pratica.hasAnaliseSolo"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("InputSelect", {
            attrs: {
              label: "Técnica(s) utilizada(s) na recuperação da área",
              multiSelect: "",
              nomeAba: _vm.nomeAba,
              rulesInput: "required",
              obrigatorio: true,
              opcoes: _vm.opcoesTecnicaRecuperacao,
              widthColumn: 10
            },
            model: {
              value: _vm.pratica.tecnicasUtilizadas,
              callback: function($$v) {
                _vm.$set(_vm.pratica, "tecnicasUtilizadas", $$v)
              },
              expression: "pratica.tecnicasUtilizadas"
            }
          }),
          _vm._v(" "),
          _vm.containsOption(
            _vm.pratica.tecnicasUtilizadas,
            "OUTROS",
            "outrosTecnicasUtilizadas"
          )
            ? _c("validation-provider", {
                attrs: {
                  rules: "required",
                  mode: "lazy",
                  name: _vm.nomeAba + "/Outros Técnicas Utilizadas"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("Label", {
                                attrs: { label: "Quais?", obrigatorio: true }
                              }),
                              _vm._v(" "),
                              _c("el-input", {
                                class: { "input erro": errors.length },
                                attrs: {
                                  name: "Outras Técnicas de Recuperação"
                                },
                                model: {
                                  value: _vm.pratica.outrosTecnicasUtilizadas,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.pratica,
                                      "outrosTecnicasUtilizadas",
                                      $$v
                                    )
                                  },
                                  expression: "pratica.outrosTecnicasUtilizadas"
                                }
                              }),
                              _vm._v(" "),
                              errors[0]
                                ? _c("span", { staticClass: "help erro" }, [
                                    _vm._v(" " + _vm._s(errors[0]))
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  633783120
                )
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("Bioinsumos", {
        attrs: { pratica: _vm.pratica, nomeAba: _vm.nomeAba }
      }),
      _vm._v(" "),
      _c("Irrigacao", {
        attrs: { pratica: _vm.pratica, nomeAba: _vm.nomeAba }
      }),
      _vm._v(" "),
      _c("Financiamentos", {
        attrs: { pratica: _vm.pratica, nomeAba: _vm.nomeAba }
      }),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("validation-provider", {
            attrs: { mode: "lazy", name: _vm.nomeAba + "/Descrição" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c("Label", { attrs: { label: "Descrição" } }),
                        _vm._v(" "),
                        _c("el-input", {
                          class: { "input erro": errors.length },
                          attrs: {
                            name: "Descrição",
                            type: "textarea",
                            maxlength: "500",
                            "show-word-limit": ""
                          },
                          model: {
                            value: _vm.pratica.descricao,
                            callback: function($$v) {
                              _vm.$set(_vm.pratica, "descricao", $$v)
                            },
                            expression: "pratica.descricao"
                          }
                        }),
                        _vm._v(" "),
                        errors[0]
                          ? _c("span", { staticClass: "help erro" }, [
                              _vm._v(" " + _vm._s(errors[0]))
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54870557", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54870557","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App/(authenticated)/modulos/cadastro/formulario-cadastro/praticas/form-praticas/PRPD/PRPD.vue
// module id = null
// module chunks = 